export const OffersPaths = {
    sellerOffers: {
        path: "/seller-offers",
        name: "sellerOffers",
    },
    buyerOffers: {
        path: "/buyer-offers",
        name: "buyerOffers",
    }
};